import {useMemo} from "react";

import type {OptionType} from "../Select";

export function useDayOptions() {
    return useMemo(() => {
        const options: OptionType<number>[] = [];
        for (let i = -90; i < -1; i += 1) {
            options.push({
                value: i,
                label: `${Math.abs(i)} Days Before`
            });
        }
        options.push({
            value: -1,
            label: "1 Day Before"
        });
        options.push({
            value: 0,
            label: "On the day of"
        });
        options.push({
            value: 1,
            label: "1 Day After"
        });
        for (let i = 2; i <= 90; i += 1) {
            options.push({
                value: i,
                label: `${i} Days After`
            });
        }
        options.push({
            value: 180,
            label: "180 Days After"
        });
        options.push({
            value: 270,
            label: "270 Days After"
        });

        return options;
    }, []);
}
